const border = '1px solid #e5e7eb';

export const gridStyle = { display: 'flex', flexWrap: 'wrap', gap: '1.25rem', alignItems: 'stretch', margin: '1rem 0 2rem' };

export const cardStyle = (wide) => ({
    flex: wide ? '2 1 32rem' : '1 1 20rem',
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    padding: '1.25rem',
    backgroundColor: '#fff',
    border,
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
});

export const cardTitleStyle = { margin: '0 0 0.25rem', fontSize: '1.1rem', fontWeight: 700 };
export const cardDescriptionStyle = { margin: '0 0 1rem', fontSize: '0.8rem', color: '#666', lineHeight: 1.4 };

export const fieldsStyle = { display: 'flex', flexWrap: 'wrap', gap: '0.75rem', margin: '0.75rem 0 1.25rem' };
export const fieldStyle = (half) => ({ flex: half ? '1 1 9rem' : '1 1 100%', minWidth: 0 });

export const labelStyle = { display: 'block', margin: '0 0 0.25rem', fontSize: '0.78rem', fontWeight: 600, color: '#444' };

export const inputStyle = {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    height: '2.5rem',
    margin: 0,
    padding: '0 0.75rem',
    fontSize: '0.9rem',
    color: '#222',
    backgroundColor: '#fff',
    border: '1px solid #cfd3d9',
    borderRadius: '0.375rem',
    boxShadow: 'none',
};
export const textareaStyle = { ...inputStyle, height: 'auto', padding: '0.5rem 0.75rem', fontFamily: 'monospace', lineHeight: 1.4, resize: 'vertical' };

export const buttonStyle = (disabled) => ({
    alignSelf: 'flex-start',
    marginTop: 'auto',
    padding: '0.65rem 1.25rem',
    fontSize: '0.85rem',
    fontWeight: 600,
    lineHeight: 1.2,
    textTransform: 'none',
    letterSpacing: 'normal',
    color: '#fff',
    backgroundColor: '#111',
    border: 0,
    borderRadius: '0.375rem',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.45 : 1,
});
